import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { Store } from '@ngrx/store';

import { AnalyticsActions, AnalyticsFacade } from '@amfam/shared/analytics';
import { BillingAnalytics } from '@amfam/shared/models';
import { Applications, ApplicationService } from '@amfam/shared/utility/shared-services';
import { DsModalService } from '@amfam/ui-kit';

import { AutopayCardData } from './autopay-card.model';

@Component({
  selector: 'ds-autopay-card',
  templateUrl: './autopay-card.component.html',
  styleUrls: ['./autopay-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AutopayCardComponent implements OnInit {
  public static readonly authAutoPayModalID = 'authAutopayModal';

  // Input Payment Confirmation Object
  @Input() confirmationDetails;
  @Input() paymentTerm: string;
  //todo: type confirmation details
  @Input() errorList: [];

  // Event Emitters to tell the parent what event is emitted from the card.
  @Output() signupEvent = new EventEmitter<AutopayCardData>();
  @Output() customizeEvent = new EventEmitter<string>();

  showModal = false;
  authAutopay: boolean;
  isMyAccountAdmin: boolean;

  //modal details
  public authAutopayModal: string;
  public modalWidth = '596';

  // Already has a
  constructor(
    private store: Store,
    private modalService: DsModalService,
    private analyticsFacade: AnalyticsFacade,
    private applicationService: ApplicationService
  ) {}

  ngOnInit() {
    this.isMyAccountAdmin = this.applicationService.isApp(Applications.MYACCOUNT_ADMIN);
    this.authAutopayModal = this.modalService.createModalId(
      AutopayCardComponent.authAutoPayModalID
    );
  }

  signup() {
    this.analyticsFacade.trackButtonClick(BillingAnalytics.clickAutoPaySignup);
    this.modalService.open(this.authAutopayModal);
    window.setTimeout(() => {
      if (this.isMyAccountAdmin) {
        this.store.dispatch(
          AnalyticsActions.sendAnalytic({
            options: {
              page: BillingAnalytics.pageAutoPayAuthAdmin
            }
          })
        );
      }
    }, 500);
  }

  closeModal(): void {
    this.modalService.close(this.authAutopayModal);
  }

  submitPayment() {
    this.closeModal();
    this.signupEvent.emit({
      billaccountNickName: this.confirmationDetails.account,
      paymentAmount: this.paymentTerm,
      paymentMethod: this.confirmationDetails.paymentMethod.nickName,
      paymentDate: 'On Due Date'
    });
  }
}
